
// ... !!ALL "priv" data should be placed here or in the priv dir!!

import Resume from './Resume';
import navItems from './nav_items';

import env from '../lib/env';

const titleFirstWord = 'MICHAEL';
const titleSecondToLastWords = 'SW DEV';

const ux = {
  name: 'bootstrap',
  maxColumnsPerRow: 12
};

export { ux };
export default {
  deployPath: env.isDevelopment() ? '/' : '/portfolio',

  resume: Resume,
  titleFirstWord,
  titleSecondToLastWords,
  title: `${titleFirstWord} ${titleSecondToLastWords}`,

  mainIcon: 'rocket',
  navItems,

  devName: 'Michael',

  contact: {
    phone: '(???) ???-????',
    email: 'michael.software.engr@gmail.com'
  },

  socialMedia: [
    {
      name: 'github',
      title: 'Github',
      href: 'https://github.com/michael-software-engr',
      icon: 'github'
    },

    // {
    //   name: 'linkedin',
    //   title: 'LinkedIn',
    //   href: '#todo',
    //   icon: 'linkedin'
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/app_data/index.js